<template>
  <div v-if="visible" class="cookie-notice" role="dialog" aria-live="polite" aria-label="Pemberitahuan cookie">
    <p class="cookie-notice__text">
      Kami memakai cookie analitik (Google Analytics) untuk memahami cara situs ini dipakai. Cookie itu hanya
      aktif bila Anda setuju.
      <router-link :to="{ name: 'privacy' }">Kebijakan Privasi</router-link>
    </p>
    <div class="cookie-notice__actions">
      <button type="button" class="cookie-notice__btn cookie-notice__btn--ghost" @click="choose('denied')">Tolak</button>
      <button type="button" class="cookie-notice__btn" @click="choose('granted')">Terima</button>
    </div>
  </div>
</template>

<script>
import { analyticsConsent, setAnalyticsConsent } from '@/utils/analytics'

// Analytics consent (UU PDP): shown until the visitor chooses. Rendered only after mount and never under puppeteer
// (navigator.webdriver), so it is not baked into the prerendered HTML.
export default {
  name: 'CookieNotice',
  data() {
    return { visible: false }
  },
  mounted() {
    if (navigator.webdriver) return
    this.visible = analyticsConsent() === null
  },
  methods: {
    choose(value) {
      setAnalyticsConsent(value)
      this.visible = false
    },
  },
}
</script>

<style scoped>
.cookie-notice {
  position: fixed;
  left: 16px;
  right: 16px;
  bottom: 16px;
  z-index: 1050;
  max-width: 560px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px 16px;
  padding: 14px 16px;
  background: #ffffff;
  border: 1px solid #e7e6f2;
  border-radius: 12px;
  box-shadow: 0 8px 28px rgba(44, 45, 91, 0.16);
  text-align: left;
}
.cookie-notice__text {
  flex: 1 1 260px;
  margin: 0;
  color: #2c2d5b;
  font-size: 13px;
  line-height: 1.5;
}
.cookie-notice__text a {
  color: #5657a5;
  font-weight: 600;
}
.cookie-notice__actions {
  display: flex;
  gap: 8px;
  margin-left: auto;
}
.cookie-notice__btn {
  border: 1px solid #5657a5;
  background: #5657a5;
  color: #fff;
  border-radius: 8px;
  padding: 7px 16px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}
.cookie-notice__btn--ghost {
  background: #fff;
  color: #5657a5;
}
</style>
